export default ["Яйца", "Ядки", "Мляко", "Глутен"];
